module.exports = __webpack_public_path__ + "assets/media/bus.a140f434.mp4";